export enum locationTypes {
    GET_LOCATION_DATA = 'GET_LOCATION_DATA',
    ADD_NEW_LOCATION = 'ADD_NEW_LOCATION',
    SEARCH_EMAIL_VALUE = 'SEARCH_EMAIL_VALUE',
    DELETE_LOCATION_NUMBER = 'DELETE_LOCATION_NUMBER',
    FETCH_LOCATION_DATA = 'FETCH_LOCATION_DATA',
    SET_HEADER_LOCATION = "SET_HEADER_LOCATION"
}